import $ from 'jquery';

const filterBtns = document.querySelectorAll('.timeline-filter');
let filterList = [];

function updateTimeline() {
  const timelineCards = document.querySelectorAll('.timeline-card');
  timelineCards.forEach((card) => {
    const container = card.parentElement;
    // eslint-disable-next-line no-param-reassign
    container.hidden = true;
    filterList.forEach((category) => {
      if (card.getAttribute('data-category').includes(category)) {
        // eslint-disable-next-line no-param-reassign
        container.hidden = false;
      }
    });
  });
}

function filterTimeline() {
  filterList = [];
  filterBtns.forEach((elem) => {
    if (elem.checked) {
      filterList.push(elem.value);
    }
  });
}

// eslint-disable-next-line func-names
filterBtns.forEach((btn) => btn.addEventListener('change', function () {
  this.toggleAttribute('checked');
  filterTimeline();
  updateTimeline();
}));

function setActiveBtn() {
  const scroll = $(window).scrollTop();
  // if at top of page reset default active button
  if (scroll === 0) {
    $('.timeline-control.active-timeline').removeClass('active-timeline');
    $('.timeline-control').first().addClass('active-timeline');
  } else {
    // or check where on page and set active button on that
    // eslint-disable-next-line func-names
    $('.timeline-control').each(function () {
      const currentSection = $(this).data('target');
      const currentSectionId = $(`#${currentSection}`);
      const topOfSection = currentSectionId.position().top;
      const heightOfSection = topOfSection + currentSectionId.height();
      if (topOfSection <= scroll && topOfSection + heightOfSection > scroll) {
        $('.timeline-control.active-timeline').removeClass('active-timeline');
        $(this).addClass('active-timeline');
      }
    });
  }
}

window.addEventListener('load', () => {
  setActiveBtn();
  $(window).scroll(() => {
    setActiveBtn();
  });
  $(window).resize(() => {
    setActiveBtn();
  });
});
